import { Divider } from '@mui/material';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { useTimer } from 'react-timer-hook';

import DoneImage from '../../../../../../../assets/images/done.svg?url';
import useIntakeData from '../../../../../../../services/intakeDataService/index';
import { add } from '../../../../../../../services/timeService';
import { unitOfTime } from '../../../../../../../services/timeService/types';
import styles from './index.module.scss';
import ProfileContent, { LINK_TIMER } from './ProfileContent';
import { SupportLink } from './SupportLink';
import { WarningContent } from './WarningContent';

const SentSmsDoneView = ({ patientUuid }: { patientUuid?: string }) => {
  const { state } = useIntakeData();
  const { seconds, restart } = useTimer({
    expiryTimestamp: add(unitOfTime.seconds, LINK_TIMER).toDate(),
  });
  const expiryMessage =
    seconds > 0 ? '(This link expires after 14 days)' : 'The link will expire in 14 days.';

  return (
    <div className={classNames('flex flex-col gap-12', styles.root)}>
      <div className="flex flex-col items-center text-center">
        <img src={DoneImage} className={styles.doneImage} />
        <h5 className={classNames('text-2xl font-bold text-center', styles.title)}>
          Invite Sent Successfully!
        </h5>
        {`An invitation to OneStep has been sent to +${`${state?.phoneNumber?.slice(
          0,
          2,
        )}*****${state?.phoneNumber?.slice(-2)}`}. `}
        <span>{expiryMessage}</span>
      </div>
      <Divider />
      <div className={styles.innerGap}>
        <ProfileContent patientUuid={patientUuid} timer={seconds} setTimer={restart} />
        <WarningContent />
        <SupportLink />
      </div>
    </div>
  );
};

export default observer(SentSmsDoneView);
